"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
// Constants
var timeConstants = require("./constants/time.json");
var alphaConstants = require("./constants/alpha.json");
var fractionConstants = require("./constants/fractions.json");
// Functions
var alpha_1 = require("./functions/alpha");
var conditionals_1 = require("./functions/conditionals");
var strings_1 = require("./functions/strings");
var time_1 = require("./functions/time");
var symbols_1 = require("./functions/symbols");
var math_1 = require("./functions/math");
module.exports = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, alpha_1.alphaFunctions), conditionals_1.conditionalFunctions), math_1.mathFunctions), strings_1.stringFunctions), symbols_1.symbolFunctions), time_1.timeFunctions), { alphabet: __assign(__assign({}, alphaConstants), { strings: {
            LOWERCASE: alphaConstants.LOWERCASE.join(""),
            UPPERCASE: alphaConstants.UPPERCASE.join(""),
            LOWERCASE_VOWELS: alphaConstants.LOWERCASE_VOWELS.join(""),
            UPPERCASE_VOWELS: alphaConstants.UPPERCASE_VOWELS.join(""),
            LOWERCASE_NON_VOWELS: alphaConstants.LOWERCASE_NON_VOWELS.join(""),
            UPPERCASE_NON_VOWELS: alphaConstants.UPPERCASE_NON_VOWELS.join(""),
        } }), fraction: fractionConstants, time: timeConstants });
//# sourceMappingURL=index.js.map